export enum ResinIds {
  SprintRayModelGray = '2002',
  SprintRayModelGray2 = '2003',
  SprintRayModelTan2 = '2004',
  SprintRayModelWhite = '2005',
  SprintRayModelWhite2 = '2006',
  SprintRayFlex = '2008',
  SprintRayFirm = '2009',
  SprintraySplint = '3001',
  SprintRayOnX = '3010',
  KeySplintSoft = '7001',
  DentsplySironaLucitone = '13001',
  SprintRayNightGuardFlex2OceanBlue = '2060',
  SprintRayNightGuardFlex2SimplyClear = '2061',
  SprintRayNightGuardFirm2MidnightPurple = '2062',
}
